// Generated by ReScript, PLEASE EDIT WITH CARE


function makeMatrixKey(studentId, id) {
  return studentId + "/" + id;
}

function calcPercent(numerator, denominator) {
  return Math.ceil(numerator / denominator * 100.00) | 0;
}

export {
  makeMatrixKey ,
  calcPercent ,
}
/* No side effect */
